import { render, staticRenderFns } from "./CustomProduct.vue?vue&type=template&id=9b65ad3a&"
import script from "./CustomProduct.vue?vue&type=script&lang=js&"
export * from "./CustomProduct.vue?vue&type=script&lang=js&"
import style0 from "./CustomProduct.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports